import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import SearchView from "../../../widgets/SearchView";
import WorkExperienceSetupSearchForm from './../WorkExperience/WorkExperienceSetupSearchForm';
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "./../../../ViewUtils";
import withMenuPermission from "../../../widgets/withMenuPermission";


const headCells = [
    { id: 'WorkExperienceCode', numeric: false, disablePadding: true, label: 'Work Experience Programme Code' },
    { id: 'WorkExperienceTitle', numeric: false, disablePadding: true, label: 'Work Experience Programme Title' },
    { id: 'OFOOccupation', numeric: false, disablePadding: true, label: 'OFO Occupation Code' },
    { id: 'Qualification', numeric: false, disablePadding: true, label: 'Qualification' }
];

const utils = new ViewUtils();

class WorkExperienceSetupSearch extends Component {
    constructor(props) {
        super(props)

        let model = {
            WorkExperienceCode: "",
            WorkExperienceTitle: ""
        }

        this.searchParameters = !utils.isNull(this.props.programmeId) ?
            [
                { Name: "id", Value: this.props.programmeId },
                { Name: "WorkExperienceCode", Value: "" },
                { Name: "WorkExperienceTitle", Value: "" }
            ]
            :
            [
                { Name: "WorkExperienceCode", Value: "" },
                { Name: "WorkExperienceTitle", Value: "" },
            ]

        this.state = {
            model: model,
            selectedWorkExperienceProgramme: null,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove WorkExperience', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/WorkExperiencesetup/getsearch"}
                    entityViewPath='/WorkExperiencesetup'
                    title='WorkExperience'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="WorkExperienceTitle" mode={this.props.mode}
                    SecondDescriptionProp = "WorkExperienceCode"
                    keyUpSwitch={this.state.keyUpSwitch}
                    history={this.props.history}
                    multiSelect={this.props.multiSelect}
                    deleteUrl={"api/sims/WorkExperienceSetup/removeWorkExperience"} useDeletePost={true}
                    promptTitle={"Remove WorkExperience Programme"} selectionCallbackMode={this.props.selectionCallbackMode}
                    promptContent={"Removing the WorkExperience programme is a permanent action and the WorkExperience programme will not be available going forward. Are you sure you want to remove this WorkExperience programme?"}
                >
                    <WorkExperienceSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>

        );
    }
}

export default withRouter(withMenuPermission(WorkExperienceSetupSearch));

